import * as errorTexts from '../../const/ErrorMessages/FileErrorMessages';

export function validateFileType(file) {
    if (file.type !== "image/jpeg" && file.type !== "image/bmp" && file.type !== "image/png" && file.type !== "application/pdf" && file.type !=="application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        throw new Error(errorTexts.INVALID_FILE_FORMAT);
    }
}

export function validateFileSize(file) {
    const maxFileSize = 5242880;
    if (file.size > maxFileSize) {
        throw new Error(errorTexts.VALIDATE_FILE_MAX_SIZE);
    }
}

export function validateFileContent(base64) {
    if (base64 === "data:") {
        throw new Error(errorTexts.VALIDATE_FILE_CONTENT);
    }
}

export function validateThatFileToAddNotExistingInAddedFiles(fileToAdd, files) {
    if(files.find((file) => file.name ===fileToAdd.name)){
        throw new Error(errorTexts.FILE_TO_ADD_EXIST_IN_FILE_ARRAY);
    }
}

export function validateThatFileToAddNotExceedMaxFilesNumber(files) {
    if(files.length ===3){
        throw new Error(errorTexts.VALIDATE_FILES_MAX_NUMBER);
    }
}


// WEBPACK FOOTER //
// ./src/actions/Validators/FileValidator.js